import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@elphasecure/elpha-design-system'
import { ReactElement } from 'react'
import { Check, Union } from '../assets/svgs'

export interface IEnabledListItem {
  enabledText: ReactElement | string
  disabledText: ReactElement | string
  enabled: boolean
  notCircled?: boolean
}

interface IEnabledListProps {
  data: IEnabledListItem[]
  name?: string
  sx?: any
}

const Icon = ({ enabled, notCircled }) => {
  return (
    <ListItemIcon sx={{ minWidth: '2.8rem' }}>
      {!notCircled ? (
        <Box
          component="span"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '2.0rem',
            height: '2.0rem',
            borderRadius: '9999px',
            color: 'primary.600',
            backgroundColor: enabled ? 'success.main' : 'error.main',
          }}
        >
          {enabled ? <Check /> : <Union />}
        </Box>
      ) : enabled ? (
        <Box
          component="span"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '2.0rem',
            height: '2.0rem',
            borderRadius: '9999px',
            color: 'success.main',
          }}
        >
          <Check />
        </Box>
      ) : (
        <Union />
      )}
    </ListItemIcon>
  )
}

const Item = ({ enabledText, disabledText, enabled, index, notCircled }) => {
  return (
    <ListItem key={index} disableGutters sx={{ paddingY: '0.6rem' }}>
      <Icon enabled={enabled} notCircled={notCircled} />
      <ListItemText primary={enabled ? enabledText : disabledText} />
    </ListItem>
  )
}

export const EnabledList = ({ data, name = '', sx }: IEnabledListProps) => {
  return (
    <List sx={{ ...sx }}>
      {data.map((item, index) => {
        return (
          <Item
            key={`${index}-${name}`}
            index={`${index}-${name}`}
            enabledText={item.enabledText}
            disabledText={item.disabledText}
            enabled={item.enabled}
            notCircled={item.notCircled}
          />
        )
      })}
    </List>
  )
}
